import { memo } from 'react';
import useUser from 'features/auth/useUser';
import Tabs from 'ui/atoms/Tabs';
import type { RoleBasedTabsProps } from './types';

const RoleBasedTabs = ({ model, ...restProps }: RoleBasedTabsProps) => {
    const { hasRole } = useUser();

    return (
        <Tabs
            {...restProps}
            model={model.filter(({ roles }) => !roles || hasRole(roles))}
        />
    );
};

export default memo(RoleBasedTabs);
